import React from 'react';
import usePageMeta from '../../hooks/usePageMeta';
import HeroSection from './sections/HeroSection';
import QuickStats from './sections/QuickStats';
import ServicesSection from './sections/ServicesSection';
import AboutSection from './sections/AboutSection';
import FeaturesSection from './sections/FeaturesSection';
// Hidden from the UI (kept in code for future use):
// import ShippingDestinationsSection from './sections/ShippingDestinationsSection';
import ShippingDestinationsAccordion from './sections/ShippingDestinationsAccordion';
import CargoPartnersSection from './sections/CargoPartnersSection';
import BranchesSection from './sections/BranchesSection';
import HomeFaqSection from './sections/HomeFaqSection';
import FreeQuoteSection from './sections/FreeQuoteSection';

// Each section now owns its scroll animations (see src/components/motion).
const Home: React.FC = () => {
  usePageMeta({
    title: 'Cargo & Courier Services in Saudi Arabia | Sahari Cargo',
    description:
      'Door-to-door air and sea cargo from Saudi Arabia to India, Pakistan, the Philippines, UK, Nepal, Bangladesh, Sri Lanka, Singapore, Malaysia and Brunei. Free quote.',
    url: 'https://www.saharicargo.com/',
  });

  return (
    <>
      <HeroSection />
      <QuickStats />
      <ServicesSection />
      <AboutSection />
      <FeaturesSection />
      {/* Old "Our Shipping Destinations" — hidden, code kept for later.
          Re-enable by uncommenting the import above and this line. */}
      {/* <ShippingDestinationsSection /> */}
      <ShippingDestinationsAccordion />
      <CargoPartnersSection />
      <BranchesSection />
      {/* Quote sits above the FAQ so it never runs into the footer's red band. */}
      <FreeQuoteSection />
      <HomeFaqSection />
    </>
  );
};

export default Home;
